<ng-container *ngIf="options.filterable">
  <ng-container *ngIf="options.type === 'string'">
    <fury-table-filter-string
      (clearFilter)="clearFilter.next()"
      (filterChange)="filterChange.next($event)"
      [customFiltering]="customFiltering"
      [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-string>
  </ng-container>
  <ng-container *ngIf="options.type === 'initials'">
    <fury-table-filter-initials
      (clearFilter)="clearFilter.next()"
      (filterChange)="filterChange.next($event)"
      [customFiltering]="customFiltering"
      [name]="options.name"
      [setValue]="setValue"
    >{{ options.title }}
    </fury-table-filter-initials>
  </ng-container>
  <ng-container *ngIf="options.type === 'address-autocomplete'">
    <fury-table-filter-address-autocomplete
      (clearFilter)="clearFilter.next()"
      (filterChange)="filterChange.next($event)"
      [customFiltering]="customFiltering"
      [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-address-autocomplete>
  </ng-container>
  <ng-container *ngIf="options.type === 'autocomplete'">
    <fury-table-filter-autocomplete
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-autocomplete>
  </ng-container>
  <ng-container *ngIf="options.type === 'select'">
    <fury-table-filter-select
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
        [options]="data"
        [multiple]="options.multiple"
    >{{ options.title }}
    </fury-table-filter-select>
  </ng-container>
  <ng-container *ngIf="options.type === 'date'">
    <fury-table-filter-date
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-date>
  </ng-container>
  <ng-container *ngIf="options.type === 'date-time'">
    <fury-table-filter-date-time
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-date-time>
  </ng-container>
  <ng-container *ngIf="options.type === 'date-range'">
    <fury-table-filter-date-range
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-date-range>
  </ng-container>
  <ng-container *ngIf="options.type === 'task-number'">
    <fury-table-filter-task-number
        (clearFilter)="clearFilter.next()"
        (filterChange)="filterChange.next($event)"
        [customFiltering]="customFiltering"
        [name]="options.name"
    >{{ options.title }}
    </fury-table-filter-task-number>
  </ng-container>
</ng-container>
